import PagamentoLoteHistoricoComponent from "../../components/pagamento-lote/historico/PagamentoLoteHistorico.jsx";

export default function PagamentoLoteHistorico() {
  return <PagamentoLoteHistoricoComponent />;
}
